import styled from "styled-components";

export const Container = styled.div`
  margin-top: 5px;
  // width: 424px;
  width: ${(props) => props.width || "424px"};
  height: max-content;
  display: flex;
  flex-wrap: wrap;
`;

export const TileContainer = styled.div`
  min-width: 83px;
  max-width: none;
  width: auto;
  height: 36px;
  gap: 0px;
  border: 1px solid #e1e1e1;
  border-radius: 4px;
  margin: 8px 8px 0px 0px;
  cursor: pointer;
`;

export const TitleContainer = styled.div`
  height: 36px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const TextSpan = styled.span`
  font-family: DM Sans;
  font-size: 16px;
  font-weight: 500;
  line-height: 20px;
  text-align: left;
  padding: 0 8px; /* Add padding for better appearance */
  white-space: nowrap; /* Prevent text from wrapping */
`;
